angular.module('app.directives').directive('vpRemindersNotify', ($rootScope, $timeout, $interval, $compile, $templateCache, api) => ({
    restrict: 'E',

    scope: {
        target: '@',
    },

    link(scope, element, attrs) {
        scope.showReminders = false;
        scope.reminders = [];

        scope.setupReminders = () => {
            $timeout(() => {
                // generujemy widok
                const html = $templateCache.get('/app/tasks/reminders_notify.html');

                // umieszczamy na samej górze
                angular.element(scope.target).prepend($compile(html)(scope));
            });
        };

        scope.getReminders = () => {
            const remindersModel = api('reminders');

            remindersModel.list().then((response) => {
                scope.reminders = response.data;
                scope.showReminders = scope.reminders.length;
            });
        };

        scope.setReminderAsReaded = (id) => {
            const remindersModel = api(`evaluated-reminders/${id}`);

            remindersModel
                .post({
                    readed: true,
                })
                .then(() => {
                    const i = _.findIndex(scope.reminders, { id: id });

                    if (-1 < i) {
                        scope.reminders.splice(i, 1);
                        scope.showReminders = scope.reminders.length;
                        remindersModel.clearCache();
                    }
                });
        };

        // run

        $timeout(() => {
            scope.setupReminders();
            scope.getReminders();

            // przy każdej zmianie widoku umieszczamy na jego górze
            $rootScope.$on('$stateChangeSuccess', () => {
                scope.setupReminders();
            });

            // sprawdzamy przypomnienia co minutę
            $interval(() => {
                scope.getReminders();
            }, 60000);
        });
    },
}));
